module.exports = __webpack_public_path__ + "./assets/img_zhongshan_grey__62db3173ea48fa4d09aaed6c0ca4e88c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_zhongshan_grey.jpg
// module id = 649
// module chunks = 12